import { useSelector } from "react-redux";
import { formatDateTimeRu } from "../utils/formatDate";
import { resolveAnalyticsView } from "../utils/analyticsDemoData";
import { resolveAnalyticsCharts } from "../utils/analyticsCharts";
import AnalyticsCharts from "./analytics/AnalyticsCharts";

const DETAIL_COLUMNS = [
  "Пользователь",
  "Запуск",
  "Завершение",
  "Дошёл до финала",
  "Ошибки",
  "Маршрут",
];

export default function ScenarioAnalytics() {
  const game = useSelector((state) => state.user.game);
  const games = useSelector((state) => state.user.games);
  const { analytics, sessions, isDemo, demoLabel } = resolveAnalyticsView(
    game,
    games
  );
  const charts = resolveAnalyticsCharts(
    game?._id,
    games,
    sessions,
    analytics,
    isDemo
  );

  const summary = [
    { label: "Запусков", value: analytics.starts ?? 0 },
    { label: "Завершений", value: analytics.completions ?? 0 },
    { label: "Уникальных игроков", value: analytics.uniquePlayers ?? 0 },
    { label: "Ошибок", value: analytics.errors ?? 0 },
  ];

  return (
    <div className="app-analytics">
      <header className="app-analytics__header">
        <div className="app-analytics__header-main">
          <h2 className="app-analytics__title">Аналитика сценария</h2>
          {isDemo ? (
            <span className="app-analytics__badge app-analytics__badge--demo">
              Демо-данные
            </span>
          ) : null}
        </div>
        <p className="app-analytics__subtitle">
          {isDemo ? (
            <>
              Показан пример для кейса «{demoLabel}». После подключения бота
              здесь появятся реальные прохождения: кто запускал сценарий, маршрут
              по сценам, финал и ошибки.
            </>
          ) : (
            <>
              Подробная статистика прохождений: кто запускал сценарий, как
              двигался по сценам, дошёл ли до финала и где совершал ошибки.
            </>
          )}
        </p>
      </header>

      <div className="app-analytics__summary">
        {summary.map((item) => (
          <div className="app-analytics__stat" key={item.label}>
            <span className="app-analytics__stat-label">{item.label}</span>
            <strong className="app-analytics__stat-value">{item.value}</strong>
          </div>
        ))}
      </div>

      <AnalyticsCharts charts={charts} />

      <section className="app-analytics__section">
        <div className="app-analytics__section-head">
          <h3>Детализация прохождений</h3>
          {isDemo ? (
            <span className="app-analytics__badge app-analytics__badge--demo">
              {demoLabel}
            </span>
          ) : null}
        </div>

        <p className="app-analytics__section-desc">
          Для каждого игрока: время старта и завершения, маршрут по сценам,
          факт прохождения до финала и количество ошибочных действий.
        </p>

        <div className="app-table-wrap app-analytics__table-wrap">
          <table className="app-table app-analytics__table">
            <thead>
              <tr>
                {DETAIL_COLUMNS.map((col) => (
                  <th key={col}>{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sessions.length === 0 ? (
                <tr>
                  <td colSpan={DETAIL_COLUMNS.length} className="app-table__empty">
                    Данные появятся после подключения сбора статистики в боте
                  </td>
                </tr>
              ) : (
                sessions.map((session, index) => (
                  <tr key={session.id ?? index}>
                    <td>{session.displayName ?? session.userId ?? "—"}</td>
                    <td>{formatDateTimeRu(session.startedAt)}</td>
                    <td>
                      {session.completedAt
                        ? formatDateTimeRu(session.completedAt)
                        : "—"}
                    </td>
                    <td>
                      <span
                        className={`app-analytics__status app-analytics__status--${
                          session.completed ? "yes" : "no"
                        }`}
                      >
                        {session.completed ? "Да" : "Нет"}
                      </span>
                    </td>
                    <td>{session.errors ?? 0}</td>
                    <td className="app-analytics__path">
                      {session.path?.length
                        ? session.path.join(" → ")
                        : "—"}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </section>

      <section className="app-analytics__section app-analytics__section--muted">
        <h3>Что будет доступно дальше</h3>
        <ul className="app-analytics__roadmap">
          <li>История запусков по каждому пользователю Telegram</li>
          <li>Визуализация пути по сценам и точек выхода из сценария</li>
          <li>Счётчик ошибочных ответов и повторных попыток</li>
          <li>Конверсия: старт → финал, среднее время прохождения</li>
          <li>Экспорт отчёта по прохождениям</li>
        </ul>
      </section>
    </div>
  );
}
